export interface IRole {
  role: string;
}

export const Role = {
  admin: 'Admin',
  scout: 'Scout',
  athlete: 'Athlete',
};
